import $ from 'jquery';
import { scrollToElement } from './lib/utilities';

hbspt.forms.create({
  target: '#hubspot-newsroom-form',
  portalId: '3572053',
  formId: 'e2d0c3f4-8e03-4580-a44c-19ad93e5e427',
  onFormSubmit: () => scrollToElement($('#hubspot-newsroom-form'))
});
